export default __webpack_public_path__ + "static/media/home.03b811fa.jpg";